/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
const generateSettings = layout => {
  let showHideSetting;
  if (layout === "ArrowPageIntroductionCard") {
    showHideSetting = [
      { label: "Author List Title", type: "text", keyName: "pageTitle", placeholder: "Our Authors" },
      {
        label: "Author List Description",
        type: "textArea",
        keyName: "pageDescription",
        placeholder: ""
      },
      { label: "Theme", type: "colorPicker", keyName: "theme" },
      { label: "Subscribe Button", type: "checkbox", keyName: "showButton" },
      {
        label: "Button Text",
        type: "text",
        keyName: "buttonText"
      }
    ];
    return showHideSetting;
  } else {
    showHideSetting = [
      { label: "Theme", type: "colorPicker", keyName: "theme" },
      {
        label: "Border",
        type: "dropDown",
        keyName: "borderSupport",
        dropDownOptions: [
          {
            label: "With Border",
            value: true
          },
          {
            label: "Without Border",
            value: false
          }
        ]
      },
      {
        label: "Initial Author Count",
        type: "dropDown",
        keyName: "initialLoadCount",
        dropDownOptions: [
          {
            label: "3",
            value: 3
          },
          {
            label: "6",
            value: 6
          },
          {
            label: "9",
            value: 9
          },
          {
            label: "12",
            value: 12
          }
        ]
      },
      {
        label: "Load Author count",
        type: "dropDown",
        keyName: "subsequentLoadCount",
        dropDownOptions: [
          {
            label: "3",
            value: 3
          },
          {
            label: "6",
            value: 6
          },
          {
            label: "9",
            value: 9
          },
          {
            label: "12",
            value: 12
          }
        ]
      },
      {
        label: "Enable Author Bio",
        type: "checkbox",
        keyName: "enableBio"
      },
      {
        label: "Enable Social Links",
        type: "checkbox",
        keyName: "enableSocialLinks"
      }
    ];
    return showHideSetting;
  }
};

export const generateAuthorsPageSettings = layout => {
  const settingArray = {
    settings: generateSettings(layout)
  };
  return settingArray;
};
